// Khojo Aurora — per-product theme source.
// One neutral component system (aurora.css); each product shifts base + accent.
//   aegis    = dark, calm premium glass, cyan-green accent
//   sip      = LIGHT white + saffron (kept), glass components
//   bugscout = editorial dark, green accent (Stag-Beetle reference)

export function getTheme() {
  if (typeof window === "undefined") return "aegis";
  // dev/testing override: ?theme=sip|bugscout|aegis  (persisted to localStorage)
  try {
    const q = new URLSearchParams(window.location.search).get("theme");
    if (q) { window.localStorage.setItem("theme_override", q); return q; }
    const o = window.localStorage.getItem("theme_override");
    if (o) return o;
  } catch (e) { /* ignore */ }
  const sub = (window.location.hostname.split(".")[0] || "").toLowerCase();
  if (sub === "sip") return "sip";
  if (sub === "debug") return "bugscout";
  return "aegis";
}

// Set <html data-theme> ASAP so aurora.css tokens apply before paint.
export function applyTheme() {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-theme", getTheme());
  }
}

const THEMES = {
  aegis: {
    name: "AEGIS",
    tagline: "DETECT · DEFEND · SECURE",
    product: "AEGIS",
    icon: "", // emoji removed — refactored components use lucide icons
    animationType: "cyber",
    bg: "#060606",
    bgGradient: "radial-gradient(130% 120% at 50% -10%, #0E1714 0%, #080A0A 55%, #050505 100%)",
    cardBg: "rgba(255,255,255,0.04)",
    cardBorder: "rgba(255,255,255,0.09)",
    primary: "#1FD0A3",
    primaryDark: "#14A37E",
    gradient: "linear-gradient(135deg, #1FD0A3, #14A37E)",
    btnText: "#06140A",
    textPrimary: "#FFFFFF",
    textSecondary: "#C8CFD8",
    textMuted: "#8A93A0",
    inputBg: "rgba(255,255,255,0.04)",
    inputBorder: "rgba(255,255,255,0.12)",
    url: "https://aegis.getkhojo.com",
  },
  sip: {
    name: "SIP TESTER",
    tagline: "TEST · ANALYZE · RESOLVE",
    product: "SIP",
    icon: "",
    animationType: "waves",
    bg: "#FFFFFF",
    bgGradient: "radial-gradient(130% 120% at 50% -10%, #FFFFFF 0%, #FFF8F2 52%, #FFEEDF 100%)",
    cardBg: "rgba(255,255,255,0.72)",
    cardBorder: "rgba(20,22,26,0.08)",
    primary: "#FF6B00",
    primaryDark: "#C65400",
    gradient: "linear-gradient(135deg, #FF6B00, #FF8C42)",
    btnText: "#FFFFFF",
    textPrimary: "#1A1A1A",
    textSecondary: "#4A5060",
    textMuted: "#7A828C",
    inputBg: "#FFFFFF",
    inputBorder: "rgba(20,22,26,0.12)",
    url: "https://sip.getkhojo.com",
  },
  bugscout: {
    name: "KHOJO BUGSCOUT",
    tagline: "FIND · FIX · SHIP",
    product: "BUGSCOUT",
    icon: "",
    animationType: "editorial",
    bg: "#0A0A0A",
    bgGradient: "radial-gradient(130% 120% at 50% -10%, #121310 0%, #0C0C0A 55%, #070707 100%)",
    cardBg: "rgba(255,255,255,0.04)",
    cardBorder: "rgba(255,255,255,0.09)",
    primary: "#29BF12",
    primaryDark: "#1E9E0E",
    gradient: "linear-gradient(135deg, #34D419, #1E9E0E)",
    btnText: "#06140A",
    textPrimary: "#F2F0EA",
    textSecondary: "#B8B5AC",
    textMuted: "#7A776E",
    inputBg: "rgba(255,255,255,0.04)",
    inputBorder: "rgba(255,255,255,0.12)",
    url: "https://debug.getkhojo.com",
  },
};

export const getBrand = () => THEMES[getTheme()] || THEMES.aegis;

export const PARENT_URL = "https://getkhojo.com";
